import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <span className="text-8xl font-heading font-bold gradient-text">404</span>
        <h1 className="text-2xl font-heading font-bold mt-4 mb-4">Página no encontrada</h1>
        <p className="text-muted-foreground mb-8">
          La página que buscas no existe. Vuelve al inicio para continuar.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button className="btn-primary" asChild>
            <Link to="/"><Home className="w-4 h-4 mr-2" />Ir al inicio</Link>
          </Button>
          <Button variant="outline" onClick={() => window.history.back()}>
            <ArrowLeft className="w-4 h-4 mr-2" />Volver
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFound;
